import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { LEGAL_PAGES, LEGAL_LINKS } from "../data/legal";

export default function LegalPage() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];

  if (!page) return <Navigate to="/legal/terms" replace />;

  return (
    <div data-testid={`legal-page-${slug}`} className="relative">
      <div className="bg-grid pointer-events-none absolute inset-0 h-64 opacity-20 mask-fade-b" />
      <div className="relative z-10 mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-brand-silver transition-colors duration-300 hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="mt-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-brand-royal/30 bg-brand-navy/40 text-brand-cyan">
            <FileText className="h-5 w-5" />
          </div>
          <span className="font-mono-data text-xs uppercase tracking-[0.2em] text-brand-silver">
            {page.updated}
          </span>
        </div>

        <h1 className="mt-5 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
          {page.title}
        </h1>

        <div className="mt-10 space-y-8">
          {page.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-xl font-semibold text-white">{s.heading}</h2>
              <p className="mt-2 text-base leading-relaxed text-brand-silver">{s.body}</p>
            </section>
          ))}
        </div>

        {/* Other legal pages */}
        <div className="mt-14 border-t border-brand-navy pt-8">
          <p className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-brand-cyan">
            More legal
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            {LEGAL_LINKS.filter((l) => l.slug !== slug).map((l) => (
              <Link
                key={l.slug}
                to={`/legal/${l.slug}`}
                className="rounded-lg border border-brand-navy px-4 py-2 text-sm text-brand-silver transition-all duration-300 hover:border-brand-cyan/50 hover:text-white"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
